/**
 * shared/utils/csp-nonce.js
 * CSP 静态 nonce 适配（与 zm_teacher/src/utils/csp-nonce.js 同源，供 shared 组件使用；
 * 2026-10-29 工具箱 ToolkitPanel 补接——题目 iframe 的 7 处组装点早已接入，工具箱漏接导致
 * 教师端(AppScan 整改 CSP: script-src 'nonce' 'strict-dynamic' + style-src 'self')下
 * 工具页内联脚本/样式被拦、页面显示异常）。
 *
 * 仅有 nonce 的环境(教师端)做全套适配; 无 CSP 站点(resource/学生端/dev) nonce 为空,
 * cspAdapt 原样返回, 零影响。
 */
import { deinlineStyles, DEINLINE_REAPPLY_SCRIPT } from './csp-style-shim'

export function getPageNonce() {
  // 浏览器在初始解析后会隐藏 nonce 属性(getAttribute 返回空串), 但 IDL 属性 .nonce 始终可读
  const el = document.querySelector('script[nonce]')
  return (el && el.nonce) || ''
}

export function stampNonce(html) {
  const nonce = getPageNonce()
  if (!html || !nonce) return html
  return html
    .replace(/(<script[^>]*?)\snonce="[^"]*"/gi, '$1')
    .replace(/<script(?=[\s>])/gi, '<script nonce="' + nonce + '"')
}

export function cspPrepareSrcdoc(html) {
  const t = deinlineStyles(html || '')
  const withShim = t.indexOf('</body>') !== -1
    ? t.replace('</body>', DEINLINE_REAPPLY_SCRIPT + '</body>')
    : t + DEINLINE_REAPPLY_SCRIPT
  return stampNonce(withShim)
}

/** 条件适配：仅教师端(nonce 存在)做 nonce 盖章+样式去内联化，其余环境原样返回 */
export function cspAdapt(html) {
  return getPageNonce() ? cspPrepareSrcdoc(html) : html
}
